const comments = [
  {
    avatar: '匿',
    name: '匿名瓜友A',
    time: '2小时前',
    content: '这个平台真的绝了！每天必刷，51爆料黑料的更新速度比微博热搜还快。昨天看到那个导演潜规则的料，今天居然就出后续了，吃瓜吃得我停不下来！',
    likes: '2.3k',
  },
  {
    avatar: '匿',
    name: '匿名瓜友B',
    time: '5小时前',
    content: '黑料不打烊确实名不虚传，凌晨三点还在更新，我们这些夜猫子的福音啊。不过有些料看着确实需要自己判断真伪，好在平台都标了可信度等级。',
    likes: '1.8k',
  },
  {
    avatar: '匿',
    name: '匿名瓜友C',
    time: '8小时前',
    content: '作为一个吃瓜多年的老网民，这个51爆料网的深扒质量真的很可以。尤其是那个上市公司财务造假的系列，数据分析得特别详细，比一些财经媒体专业多了。',
    likes: '1.5k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          瓜友热评
        </h2>

        <div className="space-y-4">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-500">{c.avatar}</span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{c.content}</p>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {c.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line"></i> 分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}